import React from "react";

export const SectionHeader: React.FC = props => (
  <header>
    <h2>{props.children}</h2>
  </header>
);
